export const requiredReadingTooltipText = 'Obligatorisk analys'